import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import { Box, Card, TextField, Typography, Toolbar, Checkbox, FormControlLabel } from '@material-ui/core';
import useReservationStyles from './reservationStyles';
import { localization } from '../../../config';

const TableProduit = ({ data, onRowClick }) => {
    const [filteredData, setFilteredData] = useState(data || []);
    const [filter, setFilter] = useState('');
    const [refFilter, setRefFilter] = useState('');
    const [clickedOf, setClickedOf] = useState(null);
    const [showReservable, setShowReservable] = useState(false);
    const [showReserved, setShowReserved] = useState(false);
    const classes = useReservationStyles();

    useEffect(() => {
        setFilteredData(
            data.filter(row => {
                const matchesFilter = filter === '' || row.of.toString().includes(filter);
                const matchesRefFilter = refFilter === '' || row.ref.includes(refFilter);
                setClickedOf(null);
                if (showReservable && showReserved) {
                    return matchesFilter && matchesRefFilter && (!row.dejaReserve || Number(row.of_reservation) !== 0);
                } else if (showReservable) {
                    return matchesFilter && matchesRefFilter && !row.dejaReserve && Number(row.of_reservation) === 0;
                } else if (showReserved) {
                    return matchesFilter && matchesRefFilter && Number(row.of_reservation) !== 0;
                }

                return matchesFilter && matchesRefFilter;
            })
        );
    }, [filter, refFilter, showReservable, showReserved, data]);

    const countReservable = filteredData.filter(row => !row.dejaReserve && Number(row.of_reservation) === 0).length;
    const countReserve = filteredData.filter(row => Number(row.of_reservation) !== 0).length;

    const handleRowClick = (event, rowData) => {
        if (rowData.of === clickedOf) {
            setClickedOf(null);
            onRowClick(null);
        } else {
            onRowClick(rowData);
            setClickedOf(rowData.of);
        }
    };

    const smallCellStyle = { fontSize: 13, lineHeight: 1.25, padding: '6px 8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
    const headerStyle = { fontSize: 12, fontWeight: 600, lineHeight: 1.15, padding: '6px 8px', whiteSpace: 'nowrap' };

    return (
    <Card className="scrollable-table" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box className={classes.filterRow} mb={1} mt={1}>
                <TextField
                    label="Ref"
                    variant="outlined"
                    value={refFilter}
                    size='small'
                    onChange={(e) => setRefFilter(e.target.value)}
                    className="rounded-field"
                    style={{ width:90 }}
                />
                <TextField
                    label="N° OF"
                    variant="outlined"
                    value={filter}
                    size='small'
                    onChange={(e) => setFilter(e.target.value)}
                    className="rounded-field"
                    style={{ width:90 }}
                />
                <FormControlLabel
                    className={classes.checkLabel}
                    control={<Checkbox checked={showReservable} onChange={(e) => setShowReservable(e.target.checked)} color="primary" />}
                    label="Réservable"
                />
                <FormControlLabel
                    className={classes.checkLabel}
                    control={<Checkbox checked={showReserved} onChange={(e) => setShowReserved(e.target.checked)} color="primary" />}
                    label="Réservé"
                />
            </Box>
            <MaterialTable
                columns={[
                    { title: 'OF', field: 'of', width: 90, type: 'numeric', cellStyle: smallCellStyle, headerStyle },
                    { title: 'Métal', field: 'metal', width: 70, cellStyle: smallCellStyle, headerStyle },
                    { title: 'Ref', field: 'ref', width: 60, type: 'numeric', align: 'center', cellStyle: smallCellStyle, headerStyle },
                    { title: 'Designation', field: 'designation', width: 140, cellStyle: smallCellStyle, headerStyle, render: r => <span style={{ display:'inline-block', maxWidth:140 }} title={r.designation}>{r.designation}</span> },
                    { title: 'Statut', field: 'statut', width: 70, cellStyle: smallCellStyle, headerStyle },
                    { title: 'Client', field: 'client', width: 150, cellStyle: smallCellStyle, headerStyle, render: r => <span style={{ display:'inline-block', maxWidth:150 }} title={r.client}>{r.client}</span> },
                    { title: 'Doigt', field: 'dim', width: 55, type: 'numeric', align: 'center', cellStyle: smallCellStyle, headerStyle, render: r => r.dim === '0' ? '' : r.dim }
                ]}
                data={filteredData}
                onRowClick={handleRowClick}
                options={{
                    paging: false,
                    search: false,
                    padding: 'dense',
                    headerStyle,
                    rowStyle: rowData => ({
                        ...(rowData.of === clickedOf && Number(rowData.of_reservation) !== 0 ? { backgroundColor: 'rgba(41, 237, 81, 1)' } :
                            rowData.of === clickedOf ? { backgroundColor: 'rgba(53, 154, 255,1)' } :
                                Number(rowData.of_reservation) !== 0 ? { backgroundColor: 'rgba(41, 237, 81, 0.5)' } :
                                    !rowData.dejaReserve ? { backgroundColor: 'rgba(155, 205, 255, 1)' } : {}),
                        fontSize: 12,
                        lineHeight: '1.15'
                    })
                }}
                title=""
                components={{
                    Toolbar: () => (
                        <Toolbar style={{ minHeight:34 }}>
                            <div style={{ flex:1, textAlign:'center' }}>
                                <Typography variant="subtitle2" style={{ fontWeight:600 }}>Produits en Commande</Typography>
                                <Box display="flex" justifyContent="center" mt={0.5}>
                                    {countReservable !== 0 && <Typography variant="caption" style={{ backgroundColor: 'rgba(155,205,255,1)', padding: '1px 6px', borderRadius: 4, marginRight: 6 }}>Réservable: {countReservable}</Typography>}
                                    {countReserve !== 0 && <Typography variant="caption" style={{ backgroundColor: 'rgba(41,237,81,0.5)', padding: '1px 6px', borderRadius: 4 }}>Réservé: {countReserve}</Typography>}
                                </Box>
                            </div>
                        </Toolbar>
                    )
                }}
                localization={localization}
                style={{ flex:1, display:'flex', flexDirection:'column' }}
            />
        </Card>
    );
};

export default TableProduit;
